module.exports = __webpack_public_path__ + "img/quicktips24.472485a1.svg";